/* eslint-disable */
// Universal Global Search — per-type row renderer (Phase C). Item-style rows for
// Items + Developments (dev-flavored: dev-no + stage + designer); avatar/meter for
// Designers; monogram/meter for Brands; amber tile for Portals/Pages; lens tile for
// Lenses. Match-highlight via <mark>. Consumes the scoped .gsRoot styles.
import React from 'react';
import styles from './globalSearch.module.css';
import { SmartImg } from '../../utils';
import { familyMeta } from '../../portals/data/lensBank/lensFamilies';

function hl(text, q) {
  const s = String(text ?? '');
  if (!q) return s;
  const i = s.toLowerCase().indexOf(q.toLowerCase());
  if (i < 0) return s;
  return [s.slice(0, i), <mark key="m">{s.slice(i, i + q.length)}</mark>, s.slice(i + q.length)];
}
const Glasses = () => (
  <svg className={styles.glassIco} viewBox="0 0 60 34" fill="none" stroke="#2c2417" strokeWidth="2.4">
    <circle cx="15" cy="18" r="11" fill="#f4efe6" /><circle cx="45" cy="18" r="11" fill="#f4efe6" /><path d="M26 16h8" /><path d="M4 14 1.5 11" /><path d="M56 14 58.5 11" />
  </svg>
);
const Arrow = () => <svg viewBox="0 0 24 24" fill="none" strokeWidth="2"><path d="M5 12h14" /><path d="m13 6 6 6-6 6" /></svg>;
const Go = ({ label }) => <span className={styles.goHint}>{label}<Arrow /></span>;
const pct = (n, max) => `${Math.max(3, Math.round((n / (max || 1)) * 100))}%`;

export function GlobalSearchRow({ d, q }) {
  if (d.k === 'item') {
    const img = (d.images || [])[0];
    const meta = [d.brand, d.shape1 || d.shape, d.gender || d.frameCategory].filter(Boolean);
    return (<>
      <div className={styles.thumb}>{img ? <SmartImg displayWidth={92} src={img} alt="" /> : <Glasses />}</div>
      <div className={styles.rMain}>
        <div className={styles.rTop}><span className={styles.rName}>{hl(d.model || d.brand || 'Item', q)}</span>{d.sku && <span className={styles.rSku}>{hl(d.sku, q)}</span>}</div>
        <div className={styles.rMeta}>{meta.map((m, i) => <React.Fragment key={i}>{i > 0 && <span className={styles.sep} />}<span>{hl(m, q)}</span></React.Fragment>)}</div>
      </div>
      <div className={styles.rRight}><Go label="Open" /></div>
    </>);
  }
  if (d.k === 'dev') {
    const x = d.data || d;
    const img = (x.images || d.images || [])[0];
    const stage = (x.stage_status || '').split(' ')[0];
    return (<>
      <div className={styles.thumb}>{img ? <SmartImg displayWidth={92} src={img} alt="" /> : <Glasses />}</div>
      <div className={styles.rMain}>
        <div className={styles.rTop}><span className={styles.rName}>{hl(x.dev_number || '—', q)}</span></div>
        <div className={styles.rMeta}>{stage && <span>{stage}</span>}{stage && x.designer && <span className={styles.sep} />}{x.designer && <span>{hl(x.designer, q)}</span>}</div>
      </div>
      <div className={styles.rRight}><Go label="Open" /></div>
    </>);
  }
  if (d.k === 'designer') {
    const init = d.name.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();
    return (<>
      <div className={styles.avatar}>{init}</div>
      <div className={styles.rMain}>
        <div className={styles.rTop}><span className={styles.rName}>{hl(d.name, q)}</span></div>
        <div className={styles.rMeta}>Designer<span className={styles.sep} />{d.devs} developments</div>
      </div>
      <div className={styles.rRight}>
        <div className={styles.meter}><span className={styles.mNum}>{d.devs} devs</span><span className={styles.mBar}><i style={{ width: pct(d.devs, d.max) }} /></span></div>
        <Go label="View work" />
      </div>
    </>);
  }
  if (d.k === 'brand') {
    const p = d.name.replace(/[^A-Za-z ]/g, '').split(' ').filter(Boolean);
    const mono = ((p[0]?.[0] || '') + (p[1]?.[0] || p[0]?.[1] || '')).toUpperCase();
    return (<>
      <div className={styles.mono}>{mono}</div>
      <div className={styles.rMain}>
        <div className={styles.rTop}><span className={styles.rName}>{hl(d.name, q)}</span></div>
        <div className={styles.rMeta}>Brand<span className={styles.sep} />{d.items} items in catalog</div>
      </div>
      <div className={styles.rRight}>
        <div className={styles.meter}><span className={styles.mNum}>{d.items} items</span><span className={styles.mBar}><i style={{ width: pct(d.items, d.max) }} /></span></div>
        <Go label="View items" />
      </div>
    </>);
  }
  if (d.k === 'portal') {
    return (<>
      <div className={`${styles.iTile} ${d.grad ? styles.grad : ''}`}><svg viewBox="0 0 24 24" fill="none" strokeWidth="2" dangerouslySetInnerHTML={{ __html: d.ico }} /></div>
      <div className={styles.rMain}>
        <div className={styles.rTop}><span className={styles.rName}>{hl(d.name, q)}</span><span className={styles.accessDot} title="You have access" /></div>
        <div className={styles.rMeta}>{d.tag}</div>
      </div>
      <div className={styles.rRight}><Go label="Open portal" /></div>
    </>);
  }
  if (d.k === 'page') {
    return (<>
      <div className={styles.iTile}><svg viewBox="0 0 24 24" fill="none" strokeWidth="2" dangerouslySetInnerHTML={{ __html: d.ico }} /></div>
      <div className={styles.rMain}>
        <div className={styles.rTop}><span className={styles.rName}>{hl(d.name, q)}</span></div>
        <div className={styles.rMeta}>{d.crumb}</div>
      </div>
      <div className={styles.rRight}><Go label="Go to page" /></div>
    </>);
  }
  if (d.k === 'lens') {
    const fg = familyMeta(d.family).g;
    return (<>
      <div className={styles.iTile}><svg viewBox="0 0 24 24" fill="none" strokeWidth="2"><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="3.4" /></svg></div>
      <div className={styles.rMain}>
        <div className={styles.rTop}><span className={styles.dot12} style={{ background: `linear-gradient(180deg, ${fg[0]}, ${fg[1]})` }} /><span className={styles.rName}>{hl(d.lens_no, q)}</span></div>
        <div className={styles.rMeta}>{d.raw_name || d.family || 'Lens'}</div>
      </div>
      <div className={styles.rRight}><Go label="Open lens" /></div>
    </>);
  }
  if (d.k === 'ltd') {
    return (<>
      <div className={styles.iTile}><svg viewBox="0 0 24 24" fill="none" strokeWidth="2"><path d="M9 3h6" /><path d="M10 3v6l-5 8.5A2 2 0 0 0 7 21h10a2 2 0 0 0 2-3.5L14 9V3" /><path d="M7.5 15h9" /></svg></div>
      <div className={styles.rMain}>
        <div className={styles.rTop}><span className={styles.rName}>{hl(d.code, q)}</span>{d.lens_no && <span className={styles.rSku}>{hl(d.lens_no, q)}</span>}</div>
        <div className={styles.rMeta}>{[d.name, d.status].filter(Boolean).map((m, i) => <React.Fragment key={i}>{i > 0 && <span className={styles.sep} />}<span>{hl(m, q)}</span></React.Fragment>)}</div>
      </div>
      <div className={styles.rRight}><Go label="Open LTD" /></div>
    </>);
  }
  if (d.k === 'order') {
    const title = d.pi || d.item_no || 'Order';
    const meta = [d.source === 'desk' ? 'Order Desk' : 'Orders Book', d.item_no, d.model !== d.item_no ? d.model : '', d.material].filter(Boolean);
    return (<>
      <div className={styles.iTile}><svg viewBox="0 0 24 24" fill="none" strokeWidth="2"><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 8h8M8 12h8M8 16h5" /></svg></div>
      <div className={styles.rMain}>
        <div className={styles.rTop}><span className={styles.rName}>{hl(title, q)}</span>{d.collection && <span className={styles.rSku}>{hl(d.collection, q)}</span>}</div>
        <div className={styles.rMeta}>{meta.map((m, i) => <React.Fragment key={i}>{i > 0 && <span className={styles.sep} />}<span>{hl(m, q)}</span></React.Fragment>)}</div>
      </div>
      <div className={styles.rRight}><Go label="Open order" /></div>
    </>);
  }
  if (d.k === 'acetate') {
    const swatch = d.swatch_a || '#efe8dc';
    return (<>
      <div className={styles.iTile} style={{ background: swatch }}><svg viewBox="0 0 24 24" fill="none" strokeWidth="2"><path d="M12 3 3 8l9 5 9-5-9-5Z" /><path d="m3 12 9 5 9-5" /></svg></div>
      <div className={styles.rMain}>
        <div className={styles.rTop}><span className={styles.rName}>{hl(d.acetate_no || d.colour_name || 'Acetate', q)}</span>{d.colour_name && <span className={styles.rSku}>{hl(d.colour_name, q)}</span>}</div>
        <div className={styles.rMeta}>{[d.colour_family, d.finish].filter(Boolean).map((m, i) => <React.Fragment key={i}>{i > 0 && <span className={styles.sep} />}<span>{hl(m, q)}</span></React.Fragment>)}</div>
      </div>
      <div className={styles.rRight}><Go label="Open acetate" /></div>
    </>);
  }
  return null;
}
